import React, { useEffect, useState } from 'react'
import { Button, Col, FormControl, FormGroup, FormLabel, Row } from 'react-bootstrap'
import { Form, useNavigate, useSubmit } from 'react-router-dom'
import { Usuario } from '../Interfaces/Interfaces'
import Menu from '../Componentes/Menu';
import { MenuItems } from '../Componentes/MenuItems';
import { cambiarPass, registrarUsuario } from '../Promesas/Promesas';


interface Props{
  hamburguesa:boolean;
  setToolbar:(isActive:boolean)=>void;
  isLogin:boolean;
  usuario:Usuario;
  }
//let initialState:Usuario = {"usuario":"","rut":"","nombre":"","clave":"","apellido":""}
export const CambiarClave = (props:Props) => {
  const [contraseniaActual,setContraseniaActual] = useState("")
  const [contrasenia1,setContrasenia1] = useState("")
  const [contrasenia2,setContrasenia2] = useState("")
    //const [usuario, setUsuario] = useState<Usuario>(initialState);
    const navigate = useNavigate()
    
    const actualizar = ()=>{
        if(contrasenia1 == contrasenia2){
            if(props.usuario.clave==contraseniaActual){
                cambiarPass(props.usuario,contrasenia1).then(()=>{
                    alert("Clave actualizada")
                    navigate("/")
                }).catch(()=>{
                    alert("Algo ocurrio")
                })
            }else{
                alert("Contraseña incorrecta")
            }
        }else{
            alert("Las contraseñas no coinciden")
        }
    }
    useEffect(()=>{
      if(!props.isLogin){
        navigate('/')
      }else{
        props.setToolbar(true);
      }
    },[])
return (
  <Row>
    <Menu key="menu1" menu={props.hamburguesa}>
      <MenuItems/>
    </Menu>
    <Col>
    <Form>
      <FormGroup className="mb-3" controlId="usuario">
        <FormLabel>Contraseña Actual</FormLabel>
        <FormControl type="password" name="contraseniaActual" 
        value={contraseniaActual}
        onChange={(e)=>{setContraseniaActual(e.currentTarget.value)}}/>
      </FormGroup>
      <FormGroup className="mb-3" controlId="password">
        <FormLabel>Contrasena Nueva</FormLabel>
        <FormControl type="password" name="password" 
        value={contrasenia1}
        onChange={(e)=>{setContrasenia1(e.currentTarget.value)}}
        />
      </FormGroup>
      <FormGroup className="mb-3" controlId="password">
        <FormLabel>Repita Contrasena Nueva</FormLabel>
        <FormControl type="password" name="password" 
        value={contrasenia2}
        onChange={(e)=>{setContrasenia2(e.currentTarget.value)}}
        />
      </FormGroup>
      <Button onClick={actualizar}>Modificar</Button>
    </Form>
    </Col>
    </Row>
  )
}
